import $ from 'jquery';

export const stepSlider = function (opts) {
    var selector = typeof opts === 'object' ? opts.selector : opts;
    if (!selector) throw new Error('Stepslider jQuery selector needs to be provided.');

    $(selector).rangeslider({
        polyfill: false,
        rangeClass: 'stepslider',
        disabledClass: 'stepslider--disabled',
        horizontalClass: 'stepslider--horizontal',
        fillClass: 'stepslider__fill',
        handleClass: 'stepslider__handle',
        onInit: function () {
            // get range labels
            var stepslider = this;
            var labelsAttr = this.$element.attr('data-labels');
            var lablesHtml = getRulerRange(this.min, this.max, this.step, labelsAttr);
            this.$wrapper = this.$range.parents('.stepslider__wrapper');
            this.$wrapper.attr('id', this.identifier + '-wrapper');

            // Select events
            this.$wrapper.find('select').on('change', function () {
                stepslider.$element.val(this.value).change();
                stepslider.onSlideEnd.call(stepslider, null, this.value);
            });

            // add labels
            this.$range.append('<div class="stepslider__labels"></div><style></style>');
            this.$range.find('.stepslider__labels').append(lablesHtml);

            if (opts.onInit && typeof opts.onInit === 'function') {
                opts.onInit.call(this);
            }
        },
        onSlide: function (position, value) {
            var CssSelector = '#' + this.identifier + ' .stepslider__labels__label:nth-child(-n+' + (1 + value) + ')::after { background-color: currentColor}';

            this.$wrapper.find('style').text(CssSelector);

            if (opts.onSlide && typeof opts.onSlide === 'function') {
                opts.onSlide.apply(this, [position, value]);
            }
        },
        onSlideEnd: function (position, value) {
            this.$wrapper.find('.stepslider__tip-arrow').css('left', position + 'px');
            this.$wrapper.find('select').val(value);

            if (opts.onSlideEnd && typeof opts.onSlideEnd === 'function') {
                opts.onSlideEnd.apply(this, [position, value]);
            }
        }
    });

    function getRulerRange(min, max, step, highlights) {
        var range = '';
        var i = min;
        var val;

        while (i <= max) {
            if (highlights) {
                val = highlights.split(',').indexOf(i + '') !== -1 ? i : '';
            } else {
                val = i;
            }

            range += '<span class="stepslider__labels__label">' + val + '</span>';
            i = i + step;
        }
        return range;
    }
};

export default stepSlider;
